<template>
  <div v-if="links.length > 3">
    <div class="flex flex-wrap gap-1 __pagination">
      <template v-for="(link, key) in links">
        <div v-if="link.url === null" :key="key" class="px-3 py-2 text-sm leading-4 text-gray-300 border border-gray-200 bg-white rounded-lg select-none" v-html="link.label" />
        <Link v-else :key="key+1" class="px-3 py-2 text-sm leading-4 border rounded-lg transition-colors bg-white" :class="link.active ? 'active' : 'border-gray-200 text-gray-600 hover:border-green-700 hover:text-green-700'" :href="link.url" v-html="link.label" />
      </template>
    </div>
  </div>
</template>

<script>
import {Link} from '@inertiajs/vue3'
export default {
  props: {
    links: Array,
  },
    components: {
        Link,
    },
}
</script>
